.backdrop {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--dds-color-surface-backdrop-default);

  @media (prefers-reduced-motion: no-preference) {
    transition: opacity var(--dds-motion-surface);
  }
}

.drawer {
  z-index: var(--dds-zindex-drawer-backdrop);
}

.modal {
  z-index: var(--dds-zindex-modal-backdrop);
}

.backdrop--visible {
  opacity: 1;
}

.backdrop--hidden {
  opacity: 0;
}
